import { CreatorsListUser } from 'lib/types/users';
import { CreatorInfo } from 'components/CreatorInfo';
import { CreatorPosts } from 'components/CreatorPosts';
import { CreatorCardClickContext } from 'lib/types/events';

interface Props {
  user: CreatorsListUser;
  context?: CreatorCardClickContext;
  blur?: boolean;
  onListsUpdated?: () => void;
}

export const CreatorRow = ({
  user, context, blur = false, onListsUpdated,
}: Props) => (
  <>
    <div className={`flex items-center p-2 py-4 flex-col lg:flex-row hover:bg-hintgray hover:dark:bg-darkgray ${blur ? 'blur pointer-events-none' : ''}`} key={user.id as number}>
      <div className="w-full lg:w-2/3">
        <CreatorInfo
          user={user}
          showPro
          showLinks={!user.isHidden && !blur}
          context={context}
          onListsUpdated={onListsUpdated}
        />
      </div>
      <div className="w-full hidden lg:w-1/3 lg:block">
        <CreatorPosts posts={user.posts} />
      </div>
    </div>
  </>
);
